type WithDetailsResponse = {
  result: { data: { code: string; items: object[] }[] };
};

const mockCache = new Map<string, Promise<any>>();

const loadMock = <T = any>(path: string): Promise<T> => {
  if (!mockCache.has(path)) mockCache.set(path, fetch(`/mocks/${path}.json`).then((response) => response.json()));
  return mockCache.get(path)!;
};

const toDetailsResponse = <T extends WithDetailsResponse>(withDetails: T, brandCode: string) => {
  const items = withDetails.result.data.find((brand) => brand.code === brandCode)?.items ?? [];
  const data = items.map((item) => ({ ...item, conversionRate: null, requiredFields: null }));
  return { ...withDetails, result: { data, count: data.length, pagesNum: 1 } };
};

export { loadMock, toDetailsResponse };
